export default __webpack_public_path__ + "static/media/website.inline.ceca7f6e.svg";